import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { useEncumbranceDetailsPage } from '../context/EncumbranceDetailsPageContext';

const CommentsSection: FC = () => {
  const { t } = useTranslate();
  const { data } = useEncumbranceDetailsPage();

  return (
    <div className="encumbrance-details__card">
      <p className="encumbrance-details__card-title">{t('Comments')}</p>
      <p className="encumbrance-details__text">{data?.comment || '-'}</p>
    </div>
  );
};

export default CommentsSection;
